import React, { memo } from 'react';
import './Zohopublic.scss';
import Button from '../../Input/Button/Button';

const ZohopublicForm = ({ isHidden }) => {
    if (isHidden) return null;

    return (
        <>
            <p>
                Claim your company page on Fairygodboss by completing the form
                in a new tab.
            </p>
            <a
                href="https://forms.zohopublic.com/themuse/form/EmployerFunnel/formperma/rXYPinl8oaoef-yADKxvhzykUX01mcLbqykv44ZspLc"
                target="_blank"
                rel="noopener noreferrer"
            >
                <Button type="solid" value="Open claim form" />
            </a>
        </>
    );
};

export default memo(ZohopublicForm);
